import { getPrice } from '../price/get-price';

export interface PlatterPrice {
  totalKg : number;
  average : number; // Durchschnitt pro Kg, auf Rappen gerundet, nur Anzeige
  total   : number; // Stückpreis: Summe der Komponenten auf Rappen, plus Anrichten
}

// Must calculate exactly like \c\Platter\price() and toPrice(), see objects/platter/platter.php.
// arrangePerKg ist der Preis des Anrichtens pro angebrochenes Kg, 0 wenn nicht angehakt.
export function platterPrice(components: PlatterComponent[], data: PlatterComponentData[], date: string, arrangePerKg: number): PlatterPrice {
  let grams = 0;
  let sum   = 0;

  for (const component of components) {
    if (component.grams === 0) continue;
    const componentData = data.find(item => item.sku === component.sku);
    if (componentData === undefined) continue;
    const price = getPrice(date, 'effective', componentData.prices);
    if (!price.productVisible) continue;

    grams += component.grams;
    sum   += component.grams * milli(price.price);
  }

  if (grams === 0) return { totalKg: 0, average: 0, total: 0 };

  const totalKg = grams / 1000;
  const average = Math.floor(sum / grams / 10 + 0.5) / 100;
  const total   = Math.floor(sum / 10000 + 0.5) / 100 + arrangeCount(grams) * arrangePerKg;
  return { totalKg, average, total };
}

// Einmal pro angebrochenes Kg, 1300g also zweimal. Wie \c\Platter\arrangeCount().
export function arrangeCount(grams: number): number {
  return Math.floor((grams + 999) / 1000);
}

function milli(price: number): number {
  return Math.round(price * 1000);
}

// '' heisst alle Komponenten 0 g
export function parseComponents(json: string): PlatterComponent[] {
  if (json.trim() === '') return [];
  try {
    const data = JSON.parse(json) as PlatterComponent[];
    return Array.isArray(data) ? data : [];
  }
  catch {
    return [];
  }
}

export function componentsToJson(components: PlatterComponent[]): string {
  const items = components
    .filter(component => component.grams > 0)
    .map(component => ({ sku: component.sku, grams: component.grams }));
  return items.length === 0 ? '' : JSON.stringify(items);
}
